/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserLinkedAccounts } from './UserLinkedAccounts';
import {
    UserLinkedAccountsFromJSON,
    UserLinkedAccountsFromJSONTyped,
    UserLinkedAccountsToJSON,
    UserLinkedAccountsToJSONTyped,
} from './UserLinkedAccounts';
import type { UserStatus } from './UserStatus';
import {
    UserStatusFromJSON,
    UserStatusFromJSONTyped,
    UserStatusToJSON,
    UserStatusToJSONTyped,
} from './UserStatus';
import type { UserAttributes } from './UserAttributes';
import {
    UserAttributesFromJSON,
    UserAttributesFromJSONTyped,
    UserAttributesToJSON,
    UserAttributesToJSONTyped,
} from './UserAttributes';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    emailVerified?: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    image?: string;
    /**
     * 
     * @type {UserStatus}
     * @memberof User
     */
    status?: UserStatus;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    cashbackPercentage?: number;
    /**
     * Booking-time vehicle cashback rate as a decimal multiplier.
     * @type {number}
     * @memberof User
     */
    vehicleCashbackPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    rrmThreshold?: number;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    gondolaGoldStartDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    optOut?: boolean;
    /**
     * 
     * @type {UserLinkedAccounts}
     * @memberof User
     */
    linkedAccounts?: UserLinkedAccounts;
    /**
     * This user's referral code which can be used to make referrals.
     * @type {string}
     * @memberof User
     */
    referralCode?: string;
    /**
     * Whether this user is subscribed to Gondola emails or not.
     * @type {boolean}
     * @memberof User
     */
    subscribed: boolean;
    /**
     * Whether this user is opted in to auto-save their room rate or not.
     * @type {boolean}
     * @memberof User
     */
    autoSave?: boolean;
    /**
     * Whether this user has enabled mobile push notifications.
     * When true, the user will receive all push notifications.
     * Defaults to false.
     * 
     * @type {boolean}
     * @memberof User
     */
    mobilePushNotifications?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    source?: UserSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    fbclid?: string;
    /**
     * Last known client IP address, updated on each sign-in
     * @type {string}
     * @memberof User
     */
    clientIpAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    iosAppDownloadAt?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    androidAppDownloadAt?: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    giveAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    getAmount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    roles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    assistantTo?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    activeStatusChallenge?: number;
    /**
     * Whether the user has ever attempted a status challenge (including completed, expired, or active challenges)
     * @type {boolean}
     * @memberof User
     */
    hasHistoricalStatusChallenge?: boolean;
    /**
     * End date of the active status challenge (30 days from start)
     * @type {Date}
     * @memberof User
     */
    statusChallengeEndDate?: Date;
    /**
     * End date for earning the status tier reward (1 year from challenge start)
     * @type {Date}
     * @memberof User
     */
    statusEarningEndDate?: Date;
    /**
     * 
     * @type {UserAttributes}
     * @memberof User
     */
    attributes?: UserAttributes;
    /**
     * ISO 4217 currency code for the user's preferred display currency (e.g., USD, EUR, GBP)
     * @type {string}
     * @memberof User
     */
    preferredCurrency?: string;
}


/**
 * @export
 */
export const UserSourceEnum = {
    Meta: 'meta',
    Google: 'google',
    Reddit: 'reddit'
} as const;
export type UserSourceEnum = typeof UserSourceEnum[keyof typeof UserSourceEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('subscribed' in value) || value['subscribed'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'emailVerified': json['email_verified'] == null ? undefined : (new Date(json['email_verified'])),
        'image': json['image'] == null ? undefined : json['image'],
        'status': json['status'] == null ? undefined : UserStatusFromJSON(json['status']),
        'cashbackPercentage': json['cashback_percentage'] == null ? undefined : json['cashback_percentage'],
        'vehicleCashbackPercentage': json['vehicle_cashback_percentage'] == null ? undefined : json['vehicle_cashback_percentage'],
        'rrmThreshold': json['rrm_threshold'] == null ? undefined : json['rrm_threshold'],
        'gondolaGoldStartDate': json['gondola_gold_start_date'] == null ? undefined : (new Date(json['gondola_gold_start_date'])),
        'optOut': json['opt_out'] == null ? undefined : json['opt_out'],
        'linkedAccounts': json['linked_accounts'] == null ? undefined : UserLinkedAccountsFromJSON(json['linked_accounts']),
        'referralCode': json['referral_code'] == null ? undefined : json['referral_code'],
        'subscribed': json['subscribed'],
        'autoSave': json['auto_save'] == null ? undefined : json['auto_save'],
        'mobilePushNotifications': json['mobile_push_notifications'] == null ? undefined : json['mobile_push_notifications'],
        'source': json['source'] == null ? undefined : json['source'],
        'fbclid': json['fbclid'] == null ? undefined : json['fbclid'],
        'clientIpAddress': json['client_ip_address'] == null ? undefined : json['client_ip_address'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
        'iosAppDownloadAt': json['ios_app_download_at'] == null ? undefined : json['ios_app_download_at'],
        'androidAppDownloadAt': json['android_app_download_at'] == null ? undefined : json['android_app_download_at'],
        'giveAmount': json['give_amount'] == null ? undefined : json['give_amount'],
        'getAmount': json['get_amount'] == null ? undefined : json['get_amount'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'assistantTo': json['assistant_to'] == null ? undefined : json['assistant_to'],
        'activeStatusChallenge': json['active_status_challenge'] == null ? undefined : json['active_status_challenge'],
        'hasHistoricalStatusChallenge': json['has_historical_status_challenge'] == null ? undefined : json['has_historical_status_challenge'],
        'statusChallengeEndDate': json['status_challenge_end_date'] == null ? undefined : (new Date(json['status_challenge_end_date'])),
        'statusEarningEndDate': json['status_earning_end_date'] == null ? undefined : (new Date(json['status_earning_end_date'])),
        'attributes': json['attributes'] == null ? undefined : UserAttributesFromJSON(json['attributes']),
        'preferredCurrency': json['preferred_currency'] == null ? undefined : json['preferred_currency'],
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'email_verified': value['emailVerified'] == null ? value['emailVerified'] : value['emailVerified'].toISOString(),
        'image': value['image'],
        'status': UserStatusToJSON(value['status']),
        'cashback_percentage': value['cashbackPercentage'],
        'vehicle_cashback_percentage': value['vehicleCashbackPercentage'],
        'rrm_threshold': value['rrmThreshold'],
        'gondola_gold_start_date': value['gondolaGoldStartDate'] == null ? value['gondolaGoldStartDate'] : value['gondolaGoldStartDate'].toISOString().substring(0,10),
        'opt_out': value['optOut'],
        'linked_accounts': UserLinkedAccountsToJSON(value['linkedAccounts']),
        'referral_code': value['referralCode'],
        'subscribed': value['subscribed'],
        'auto_save': value['autoSave'],
        'mobile_push_notifications': value['mobilePushNotifications'],
        'source': value['source'],
        'fbclid': value['fbclid'],
        'client_ip_address': value['clientIpAddress'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
        'ios_app_download_at': value['iosAppDownloadAt'],
        'android_app_download_at': value['androidAppDownloadAt'],
        'give_amount': value['giveAmount'],
        'get_amount': value['getAmount'],
        'roles': value['roles'],
        'assistant_to': value['assistantTo'],
        'active_status_challenge': value['activeStatusChallenge'],
        'has_historical_status_challenge': value['hasHistoricalStatusChallenge'],
        'status_challenge_end_date': value['statusChallengeEndDate'] == null ? value['statusChallengeEndDate'] : value['statusChallengeEndDate'].toISOString().substring(0,10),
        'status_earning_end_date': value['statusEarningEndDate'] == null ? value['statusEarningEndDate'] : value['statusEarningEndDate'].toISOString().substring(0,10),
        'attributes': UserAttributesToJSON(value['attributes']),
        'preferred_currency': value['preferredCurrency'],
    };
}

